module.exports = __webpack_public_path__ + "static/media/oracle-netsuite.c607ba5c.svg";